module.exports = __webpack_public_path__ + "img/cancel_icon.15f194b3.svg";